import {useAppContext} from "../contexts/AppContext";

// Г5: централизирано изчисляване на правата от текущия потребител (GET /user).
// Докато `user` се зарежда — permissive (сървърът е истинската защита; така се
// избягва премигване на бледи бутони). Землищните права се налагат от сървъра;
// клиентът само не показва каквото не е позволено.
export const usePermissions = () => {
    const {user} = useAppContext();
    const loaded = !!user?.username;

    return {
        isAdmin: user?.role === 'admin',
        canReports: !loaded || user.role === 'admin' || user.can_reports !== false,
        canUpload: true,   // качването остава за всички (одобрено); сървърът пази по землища
        allowedEkattes: loaded && user.role !== 'admin' && user.settlements?.length
            ? user.settlements : null,   // null = всички
    };
};
